var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "edit-template-container" },
    [
      _c("LfHeaderTitle", {
        staticClass: "header-title",
        attrs: {
          title: _vm.getHeaderTitle,
          buttons: _vm.buttons,
          executeAction: _vm.onExecuteAction,
        },
      }),
      _vm.selectedTemplateData
        ? _c("section", { staticClass: "edit-template-section-container" }, [
            _c("div", { staticClass: "subject-container" }, [
              _c("span", { staticClass: "text-label" }, [
                _vm._v(_vm._s(_vm.text.subject)),
              ]),
              _c("div", { staticClass: "fake-dropdown-subject-container" }, [
                _c(
                  "button",
                  {
                    ref: "fakeDropdownSubject",
                    staticClass: "fake-dropdown-subject-button",
                    on: { click: _vm.toggleFakeDropdownSubject },
                  },
                  [
                    _vm._v(_vm._s(_vm.text.insertTags)),
                    _c("i", { class: ["angle-icon", _vm.renderAngleIcon] }),
                  ]
                ),
                _vm.isOpenFakeDropdownSubject
                  ? _c(
                      "ul",
                      { staticClass: "fake-dropdown-subject-content" },
                      _vm._l(
                        _vm.selectedTemplateData.tags.subject,
                        function (tag, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              on: {
                                click: function ($event) {
                                  return _vm.addSubjectTag(tag.tag)
                                },
                              },
                            },
                            [_vm._v(_vm._s(tag.label))]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedTemplateData.subject,
                      expression: "selectedTemplateData.subject",
                    },
                  ],
                  ref: "subjectTextInput",
                  staticClass: "subject-text",
                  domProps: { value: _vm.selectedTemplateData.subject },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.selectedTemplateData,
                        "subject",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "body-container" },
              [
                _c("span", { staticClass: "text-label" }, [
                  _vm._v(_vm._s(_vm.text.body)),
                ]),
                _c("ejs-richtexteditor", {
                  ref: "richtexteditor",
                  staticClass: "rich-text-editor",
                  attrs: {
                    height: 500,
                    toolbarSettings: _vm.toolbarSettings,
                    created: _vm.onCreateRichTextEditor,
                    actionComplete: _vm.removeDefaultContentClasses,
                    blur: _vm.removeDefaultContentClasses,
                  },
                  model: {
                    value: _vm.selectedTemplateData.body,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectedTemplateData, "body", $$v)
                    },
                    expression: "selectedTemplateData.body",
                  },
                }),
              ],
              1
            ),
          ])
        : _c("SpinnerLayerComponent", { staticClass: "spinner-layer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }